<template>
  <article class="insurace-variant-card" :class="{'insurace-variant-card--selected': isSelected}">
    <div class="insurance-card-column__first">
      <div class="insurance-card-body">
        <h3 class="insurace-variant-card__title" v-html="title" />
        <p class="insurace-variant-card__subtitle">
          {{ subtitle }}
        </p>
      </div>

      <div
        v-if="tariff === 'property' && titulPrem"
        class="insurace-card-go-container"
      >
        <div>
          <ElCheckbox
            v-model="useTitul"
            name="useTitul"
            class="titul-checkbox"
            @change="changeTitulHandler"
          />
          <span class="insurace-variant-card__subtitle">
          Титульное страхование за <span class="insurace-card-titul-price">₽&nbsp;{{ formatPrice(titulPrem) }}</span>
          </span>
        </div>
        <ElTooltip
          :raw-content="true"
          raw-content=true
          content="Защищает от возможных проблем с правом собственности на приобретаемую квартиру."
        >
          <div class="card-tooltip-container-go">
            <SvgIcon
              class="insurace-variant-card__list-item-icon-go"
              name="icon-question"
              size="small"
            />
          </div>
        </ElTooltip>
      </div>

      <div
        v-if="tariff === 'property'"
        class="insurace-card-go-container"
      >
        <ElSelect
          v-model="tariffGo"
          placeholder="Ответственность перед соседями"
          :popper-append-to-body="false"
          class="insurace-card-go-select"
          @change="changeGoHandler"
        >
          <template #prefix>
            Ответственность перед соседями
          </template>

          <ElOption
            v-for="(option, index) in getGoTariffs"
            :key="index"
            :label="option.title"
            :value="index"
          >
          </ElOption>
        </ElSelect>
        <ElTooltip
          :raw-content="true"
          raw-content=true
          content="Страхование ответственности поможет покрыть случайный ущерб нанесенный вами соседям в результате аварии инженерных систем, протечек воды или пожаре."
        >
          <div class="card-tooltip-container-go">
            <SvgIcon
              class="insurace-variant-card__list-item-icon-go"
              name="icon-question"
              size="small"
            />
          </div>
        </ElTooltip>
      </div>
    </div>

    <div class="insurance-card-column__second">
      <p class="insurace-variant-card__list-item-price">
        <strong class="insurace-variant-card__price-new--strong">
          ₽&nbsp;{{ formatPrice(cardPrice) }}
        </strong>
      </p>
      <div class="insurace-variant-card--buttons">
        <BaseButton
          class="insurace-variant-card__submit-button"
          :text="submitText"
          theme="primary-invert"
          long
          @click.native="$emit('tariff-chosen', tariff, !isSelected)"
        />
        <ElTooltip
          :raw-content="true"
          raw-content=true
          :content="cardTooltip"
        >
          <div class="card-tooltip-container">
            <SvgIcon
              class="insurace-variant-card__list-item-icon"
              name="icon-info"
              size="small"
            />
          </div>

        </ElTooltip>
      </div>
    </div>
  </article>
</template>
<script>
import SvgIcon from '@/components/ui/SvgIcon';
import BaseButton from '@/components/ui/BaseButton';
import {TARIFFS_GO} from '@/consts';
export default {
  name: 'InsuranceVariantCard',
  components: {
    BaseButton,
    SvgIcon
  },
  props: {
    useTitul: {
      type: Boolean,
      required: false,
    },
    titulPrem: {
      type: Number | null,
      required: false
    },
    tariffGo: {
      type: Number | null,
      required: false
    },
    tariff: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: true
    },
    oldPrice: {
      type: String,
      required: false,
      default: ''
    },
    price: {
      type: String,
      required: true,
    },
    submitText: {
      type: String,
      required: false,
      default: 'Выбрать'
    },
    cardPrice: {
      type: String,
      required: true,
    },
    cardTooltip: {
      type: String,
      required: true,
    },
    isSelected: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    getGoTariffs() {
      return TARIFFS_GO;
    },
  },
  methods: {
    changeGoHandler(value) {
      this.$emit('change-tariff-go', value);
    },
    changeTitulHandler(value) {
      this.$emit('change-use-titul', value);
    },
    formatPrice(price) {
      return price.toLocaleString('ru-RU', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    },
  },
}
</script>
<style scoped lang="scss">
.insurace-article-container {
  position: relative;
}

.insurace-variant-card {
  $border-radius-desktop: $border-radius-default;
  $padding-desktop: $gap-medium;
  display: flex;
  justify-content: space-between;
  position: relative;
  padding: rem($padding-desktop);
  border: 1px solid $primary-weekened;
  border-radius: rem($border-radius-desktop);
  transition: border-color $transition-duration $transition-function;

  @media #{$screen-big} {
    flex-direction: column;
  }

  &:hover {
    border-color: $primary;
  }
  &--selected {
    border-color: $bondi-blue;
    background-color: rgba($swans-down, 0.3);
    &:hover {
      border-color: $bondi-blue;
    }
  }
  &--selected & {
    &__submit-button {
      color: $white;
      background-color: $bondi-blue;
      &:focus {
        color: $white;
        background-color: $bondi-blue;
      }
      &:hover {
        color: $white;
        background-color: $bondi-blue;
      }
    }
  }
  &__title {
    $safe-margin: 10px;
    @include text-average($font-weight-bold, $line-height-normal);
    flex-grow: 1;
    margin: 0 0 rem(8px);
    @media #{$screen-big} {
      flex-grow: 0;
      width: 100%;
    }
    @media #{$screen-small} {
      font-size: rem($font-size-normal);
      flex-grow: 1;
      width: auto;
    }
    &-icon {
      $width-desktop: 25px;
      $height-desktop: 25px;
      width: rem($width-desktop);
      height: rem($height-desktop);
      &-pic {
        @include object-cover-full;
      }
    }
  }
  &__subtitle {
    @include text-small;
    margin: 0;
    @media #{$screen-big} {
      margin: 0 0 rem($gap-mini);
    }
    @media #{$screen-medium} {
      font-size: rem($font-size-mini);
    }
  }
  &__price {
    position: absolute;
    top: rem(24);
    right: rem(24);
    @media #{$screen-medium} {
      position: static;
    }
    &-old {
      @include text-average($font-weight-regular, $line-height-normal);
      display: inline-block;
      color: $color-text-muted;
      text-decoration: line-through;
      @media #{$screen-medium} {
        font-size: rem($font-size-small);
      }
    }
    &-new {
      @include text-average($font-weight-regular, $line-height-normal);
      display: inline-block;
      color: $primary-weekened;
      @media #{$screen-medium} {
        font-size: rem($font-size-small);
      }
      &--strong {
        @include text-xl($font-weight-bold);
        font-size: rem(36px);
        @media #{$screen-medium} {
          font-size: rem($font-size-medium);
        }
      }
    }
  }
  &__body {
    $vertical-padding-desktop: $gap-medium;
    margin-top: 1.2rem;
    flex-grow: 1;
    padding: rem(17px) 0 0;
    @media #{$screen-big} {
      padding: rem(8px) 0 rem(26px);
    }
  }
  &__list {
    &-item {
      @include resetting-vertical-indentation-of-first;
      display: flex;
      margin-top: rem($gap-normal);
      &-content {
        display: flex;
        gap: rem(8);
        align-items: center;
      }
      &-icon {
        color: $primary;
        cursor: pointer;
      }
      &-text {
        @include text-small;
        color: $color-text-secondary;
        @media #{$screen-medium} {
          font-size: rem($font-size-mini);
        }
      }
      &-price {
        @include text-normal($font-weight-semibold, $line-height-normal);
        text-align: center;
        color: $primary;
        @media #{$screen-medium} {
          font-size: rem($font-size-small);
        }
      }
    }
  }
  &__submit-button {
    $height-desktop: 49px;
    width: 75%;

    @media #{$screen-medium} {
      height: rem($height-desktop);
    }

    @media #{$screen-small} {
      width: 90%;
    }

    @media #{$screen-very-small} {
      width: 75%;
    }

    &:focus {
      color: $bondi-blue;
      background-color: transparent;
    }
    &:hover {
      color: $bondi-blue;
      background-color: transparent;
    }
  }

  &--buttons {
    display: flex;
    justify-content: space-between;
    margin-top: rem(15px);
    max-width: rem(190px);
    margin-left: auto;
    margin-right: auto;

    @media #{$screen-big} {
      margin-top: 0;
      margin-left: 0;
      margin-right: 0;
      max-width: 65%;
      width: 65%;
      align-items: center;
    }

    @media #{$screen-small} {
      margin-top: rem(15px);
      width: 100%;
      max-width: 100%;
    }
  }
}


.insurance-card-column {
  &__first {
    width: 60%;

    @media #{$screen-big} {
      width: 100%;
    }
  }

  &__second {
    width: 35%;
    align-content: center;

    @media #{$screen-big} {
      width: 100%;
      display: flex;
      justify-content: space-between;
      flex-direction: row;
      align-items: center;
      margin-top: rem(15px);
    }

    @media #{$screen-small} {
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      align-items: start;
    }
  }
}

.card-tooltip-container {
  height: rem(42px);
  width: rem(42px);
  border-radius: 12px;
  background-color: rgba($gallery, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.insurance-card-body {
  width: 85%;

  @media #{$screen-big} {
    width: 100%;
  }
}

.insurace-card-go-container {
  width: 100%;
  margin-top: rem(15px);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.insurace-card-go-select {
  max-width: 92%;

  @media #{$screen-small} {
    max-width: 85%;
    font-size: rem(12px);
  }
}

.card-tooltip-container-go {
  height: rem(20px);
  width: rem(20px);
  border-radius: 50%;
  background-color: rgba($dove-gray, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.insurace-variant-card__list-item-icon-go {
  height: rem(15px);
  width: rem(15px);
}

.insurace-card-titul-price {
  color: #00a1b0;
  @include text-props(18px, 21.78px, 700);

  @media #{$screen-small} {
    @include text-props(16px, 19.36px, 700);
  }
}

.titul-checkbox {
  display: inline-block;
}
</style>